import {gql} from '@apollo/client';

export const GetAttendeeQuery = gql`
  query QueryAccessCodeSession {
    self {
      id
      attendeeTags
      attendee {
        id
        name
        email
      }
      avatar
      chatTokens {
        token
      }
    }
  }
`;

export const VerifyAccessCodeMutation = gql`
  mutation VerifyAccessCode($showId: UUID!, $accessCode: String!) {
    verifyAccessCode(data: {showId: $showId, accessCode: $accessCode}) {
      id
      showId
      sessionToken
      attendeeTags
      attendee {
        id
        name
        email
      }
      avatar
      chatTokens {
        token
      }
    }
  }
`;

export const VerifyOpenLoginMutation = gql`
  mutation VerifyOpenLogin($data: VerifyOpenLoginInput!) {
    verifyOpenLogin(data: $data) {
      __typename
      ... on OpenLoginGuest {
        id
        name
        email
        sessionToken
        chatTokens
        attendeeTags
      }
      ... on DataIntegrityError {
        code
        message
      }
    }
  }
`;

export const VerifyPublicPasscode = gql`
  mutation VerifyPublicPasscode($data: VerifyPublicPasscodeInput!) {
    verifyPublicPasscode(data: $data) {
      __typename
      ... on PublicPasscodeOutput {
        id
        name
        email
        sessionToken
        chatTokens
        attendeeTags
      }
      ... on DataIntegrityError {
        code
        message
      }
    }
  }
`;
